import { useState } from 'react';
import { mergeStoreDraft } from '../utils/storeDraft';

// Merge live store updates without replacing fields edited in this form.
export default function useStoreFormDraft(store) {
  const source = store || null;
  const [state, setState] = useState(() => ({ source, draft: { ...source } }));
  let current = state;

  if (state.source !== source) {
    const draft = state.source?.id === source?.id
      ? mergeStoreDraft(source, state.source, state.draft)
      : { ...source };
    current = { source, draft };
    setState(current);
  }

  const setDraft = (value) => {
    setState((previous) => ({
      ...previous,
      draft: typeof value === 'function'
        ? value(previous.draft)
        : mergeStoreDraft(previous.draft, current.draft, value),
    }));
  };
  return [current.draft, setDraft];
}
